import type { FilterScopeRef, SaveFiltersRequest, SavedFilters } from '@/data-sources/contract';
import { api, overrideExisting } from '@/store/api/api';
import { fromSource, type Sourced } from '@/store/api/fromSource';

/**
 * Saved filters. Read once per scope when it is first entered (the store
 * keeps them afterwards — refetching would overwrite what the person is
 * doing), written by the persistence listener.
 */
export const filterStateApi = api.injectEndpoints({
  overrideExisting,
  endpoints: (build) => ({
    savedFilters: build.query<SavedFilters | null, Sourced<FilterScopeRef>>({
      queryFn: fromSource((source, ref, ctx) => source.getSavedFilters(ref, ctx)),
      keepUnusedDataFor: 0,
    }),
    saveFilters: build.mutation<null, Sourced<SaveFiltersRequest>>({
      queryFn: fromSource(async (source, request, ctx) => {
        await source.saveFilters(request, ctx);
        return null;
      }),
    }),
  }),
});
